<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("companies.tabs.statistics") }}
  UiCardSection
    RestTable(
      namespace="company_statistics"
      :headers="headers"
      :fetch-handler="getData"
      :disable-pagination="true"
      embed
    )
</template>

<script>
import ApiCompanies from "@/api/companies.js";

export default {
  data() {
    return {
      headers: [
        {
          key: "method",
          label: "Method",
          squeeze: false,
        },
        {
          key: "total",
          label: "Suggestions",
          squeeze: false,
        },
        {
          key: "true",
          label: "True",
          squeeze: false,
        },
        {
          key: "false",
          label: "False",
          squeeze: false,
        },
        {
          key: "rate",
          label: "Rate, %",
          squeeze: false,
        },
      ],
    };
  },

  methods: {
    getData(params, config) {
      return ApiCompanies.fetchStatistics(
        this.$route.params.id,
        params,
        config,
      ).then((response) => {
        return {
          items: response.data.statistics,
          meta: response.data.meta,
        };
      });
    },
  },
};
</script>
